import * as React from "react";
import type { SVGProps } from "react";
interface SVGRProps {
  title?: string;
  titleId?: string;
  desc?: string;
  descId?: string;
}
const SvgSquarePenOutlined = ({
  title,
  titleId,
  desc,
  descId,
  ...props
}: SVGProps<SVGSVGElement> & SVGRProps) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    stroke="currentColor"
    strokeLinecap="round"
    strokeLinejoin="round"
    viewBox="-.5 -.5 16 16"
    aria-hidden="true"
    data-slot="icon"
    width={24}
    height={24}
    aria-labelledby={titleId}
    aria-describedby={descId}
    {...props}
  >
    {title ? <title id={titleId}>{title}</title> : null}
    {desc === undefined ? (
      <desc id={descId}>
        {"\n    Square Pen Streamline Icon: https://streamlinehq.com\n  "}
      </desc>
    ) : desc ? (
      <desc id={descId}>{desc}</desc>
    ) : null}
    <path d="M7.1513 1.5477h-4.901c-.7733 0-1.4002.6269-1.4002 1.4002v9.8017c0 .7734.6269 1.4003 1.4003 1.4003h9.8017c.7733 0 1.4002-.6269 1.4002-1.4003V7.8488" />
    <path d="M11.6145 1.2851c.8084-.8084 2.1889-.4385 2.4848.6658a1.485 1.485 0 0 1-.3844 1.4346L7.1513 9.9491l-2.8006.7001.7002-2.8005Z" />
  </svg>
);
export default SvgSquarePenOutlined;
